import * as THREE from 'three';
import vertexShader from './../shaders/vertex.glsl'
import fragmentShader from './../shaders/fragment.glsl'
import whiteTexture from './../images/texture.jpg';
import gsap from "gsap";

//Utilities
import { camera, scene, renderer, scrinit } from './utilities/scr';

let sphereGeometry, sphereMaterial, sphere, clock, raycaster, mouse, intersects;
let texture = new THREE.TextureLoader().load(whiteTexture);

init();
animate();

function init() {

	//Init Scene Camera Renderer
	scrinit();
	clock = new THREE.Clock();

	//Raycaster and Mouse
	raycaster = new THREE.Raycaster();
	mouse = new THREE.Vector2();

	sphereGeometry = new THREE.SphereBufferGeometry(1.8, 30, 60);
	sphereMaterial = new THREE.ShaderMaterial({
		uniforms: {
			uTime: { value: 0 },
			uTexture: { type: "t", value: texture },
			uHover:{value:new THREE.Vector2(0.5, 0.5)},
			uHoverState: { value: 0 },
		},
		vertexShader,
		fragmentShader,
	})
	sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
	scene.add(sphere);
	renderer.setClearColor('whitesmoke');
}

function animate() {
	let elapsedTime = clock.getElapsedTime()
	sphereMaterial.uniforms.uTime.value = elapsedTime;
	sphere.rotation.z = elapsedTime / 10;
	sphere.rotation.x = elapsedTime / 10;

	if(intersects && intersects.length>0){
		gsap.to(sphereMaterial.uniforms.uHoverState, {
                    duration: 1,
                    value: 1
        })
	}else{
		gsap.to(sphereMaterial.uniforms.uHoverState, {
                    duration: 1,
                    value: 0
        })
	}

	requestAnimationFrame(animate);
	renderer.render(scene, camera);
}

//Event Listeners
window.addEventListener('resize', resize);
window.addEventListener( 'mousemove', onMouseMove, false );

function resize() {
	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();
	renderer.setSize(window.innerWidth, window.innerHeight);
}

function onMouseMove( event ) {
	mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
	mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
	raycaster.setFromCamera(mouse, camera);
    intersects = raycaster.intersectObjects(scene.children);
    for (let i = 0; i < intersects.length; i++) {
        let obj = intersects[0].object;
        obj.material.uniforms.uHover.value = intersects[0].uv;
    }
}